import { render, staticRenderFns } from "./Professionnalisation.vue?vue&type=template&id=12411210"
import script from "./Professionnalisation.vue?vue&type=script&lang=js"
export * from "./Professionnalisation.vue?vue&type=script&lang=js"
import style0 from "./Professionnalisation.vue?vue&type=style&index=0&id=12411210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports